// Path: ./src/app/pages/InProgress/Loadable.ts
/**
 *
 * Asynchronously loads the component for InProgress
 *
 */

import { lazyLoad } from "../../../utils/loadable";

export const InProgress = lazyLoad(
  () => import("./index"),
  (module) => module.default
);
